import $ from 'jquery'

$(document).ready(function() {
	$('.menu-toggle').click(function() {
		$(this).toggleClass('is-active')
		$('.mobile-menu-bg, .site-branding').toggleClass('when-active')
		$('#site-navigation').slideToggle()
	})

	$('#menu-primary > .menu-item').click(function() {
		$(this).toggleClass('is-active')
	})

	$('.site-header .search-icon').click(function() {
		$('.site-header .header-search').slideToggle()
	})
})
